export const agents = {
  seo: {
    title: 'Word Bistroo Sales Agent, verdien 40% terugkerende commissie',
    description: 'Verkoop next-gen restaurantsoftware in NL, BE & DE. Verdien 40% terugkerende commissie met een €1.500/maand opstartgarantie.',
  },
  hero: {
    badge: 'Nu werven we agents in Nederland, België & Duitsland',
    title_1: 'Verkoop restauranttech die zichzelf verkoopt. Verdien',
    title_em: '40% terugkerende commissie',
    title_2: 'zolang jouw klanten blijven.',
    subtitle: 'Bistroo is de next-gen e-commerce suite voor quick-service restaurants: webshops, websites, QR-bestellen, kiosks en kassa. Jij brengt de restaurants. Wij zorgen dat ze nooit meer weg willen. En jij wordt betaald, elke maand dat ze blijven.',
    cta_primary: 'Word agent',
    cta_secondary: 'Bekijk de deal ↓',
    stats: [
      { value: '40%', label: 'terugkerende commissie' },
      { value: '€1.500/mo', label: 'opstartgarantie, 4 maanden' },
      { value: 'Wekelijks', label: 'uitbetaald tijdens de opstart' },
      { value: '3', label: 'landen om in te verkopen' },
    ],
  },
  products: {
    kicker: 'Wat je verkoopt',
    heading: 'Software waar restauranthouders écht van houden.',
    lead: 'Bistroo bedient quick-service restaurants met een complete, plug-and-play bestelsuite: geen langetermijncontracten, maandelijks opzegbaar, instapprijs met een premium uitstraling. Dat maakt het een makkelijke "ja" aan de toonbank.',
    items: [
      { icon: '🛍️', title: 'Webshop & Website', text: 'Volledig aanpasbare afhaal- & bezorgwebshops plus een eigen restaurantwebsite. Eigen kanaal, eigen gasten, eigen data.' },
      { icon: '📱', title: 'QR-bestellen aan tafel', text: 'Gasten scannen, bestellen en betalen vanaf tafel. Minder loopwerk, meer omzet per dienst.' },
      { icon: '🖥️', title: 'Kiosk & Kassa', text: 'Zelfbestelkiosks en een kassamodule speciaal voor quick-service. Één suite, één abonnement, beheerd in de intuïtieve Bistroo Manager.' },
    ],
  },
  deal: {
    kicker: 'De deal',
    heading: 'Bouw aan inkomen dat groeit. Geen eenmalige bonus.',
    lead: 'De meeste salesdeals betalen één keer uit. Wij betalen je 40% van de terugkerende omzet van elk restaurant dat jij onboardt, elke maand dat ze bij Bistroo blijven. Eén keer onboarden, blijvend verdienen.',
    commission: {
      title: 'Terugkerende commissie',
      value: '40%',
      text: 'Op de terugkerende omzet van elke zakelijke klant die jij onboardt, zolang die een actieve Bistroo-partner blijft. Jouw portefeuille groeit en jouw maandinkomen groeit mee.',
    },
    retainer: {
      pill: 'Opstartgarantie',
      title: 'Je eerste 4 maanden, zonder risico.',
      value: '€1.500/mo',
      text: 'Terugkerende commissie heeft tijd nodig om op te bouwen, dus wij overbruggen dat. Onboard 8 nieuwe zakelijke klanten in een maand en wij garanderen je €1.500 die maand, wekelijks uitbetaald: converteer 2 zakelijke klanten in een week, en je krijgt die week uitbetaald.',
    },
  },
  ramp: {
    kicker: 'Zo werkt de opstartperiode',
    heading: 'Van gegarandeerde retainer naar zelfvoorzienende commissie in 4 maanden.',
    lead: 'Houd het tempo van 8 onboarded zakelijke klanten per maand vast en de rekensom doet de rest: na maand 4 heb je een portefeuille van 32+ restaurants die minimaal €1.440 aan maandelijkse commissie oplevert, en die blijft groeien met elke nieuwe klant die je toevoegt.',
    table_headers: ['Maand', 'Doel (nieuwe klanten)', 'Portefeuille totaal', 'Gegarandeerde uitbetaling'],
    table_rows: [
      ['1', '8', '8', '€1.500 (wekelijkse termijnen)'],
      ['2', '8', '16', '€1.500 (wekelijkse termijnen)'],
      ['3', '8', '24', '€1.500 (wekelijkse termijnen)'],
      ['4', '8', '32', '€1.500 (wekelijkse termijnen)'],
      ['Maand 5+', 'Jouw tempo', '32+', '€1.440+ /maand aan 40% terugkerende commissie'],
    ],
    note: 'Voorwaarden opstartretainer: maximale duur 4 maanden. De maandgarantie geldt wanneer je 8 nieuwe zakelijke klanten onboardt in die maand; de wekelijkse uitbetaling geldt in weken waarin je 2 zakelijke klanten converteert. Het bedrag van €1.440+ is de minimaal verwachte maandcommissie bij een portefeuille van 32 klanten. De werkelijke verdiensten hangen af van de modules die jouw klanten gebruiken en groeien mee met je portefeuille. Er gelden algemene voorwaarden; de volledige agentovereenkomst ontvang je tijdens de onboarding.',
    checks: [
      { strong: 'Geen plafond op je verdiensten.', text: '32 klanten is de ondergrens, niet de bovengrens. Blijf onboarden en je terugkerende inkomen blijft stapelen.' },
      { strong: 'Jij verkoopt, wij leveren.', text: 'Ons team regelt de setup, het design en de support. Jouw klanten zijn in goede handen en je portefeuille blijft gezond.' },
      { strong: 'Een eerlijk product om achter te staan.', text: 'Maandelijkse abonnementen, geen lock-in. Restaurants blijven omdat ze dat willen. En precies daarom werkt terugkerende commissie.' },
    ],
  },
  steps: {
    kicker: 'Aan de slag',
    heading: 'Van aanmelding tot eerste uitbetaling in vier stappen.',
    items: [
      { title: 'Meld je aan', text: 'Vul het aanmeldformulier in (2 minuten). Vertel ons over je netwerk en regio.' },
      { title: 'Intro & onboarding', text: 'Een persoonlijk gesprek, producttraining en je agent-toolkit: demo-omgeving, prijzen en materialen.' },
      { title: 'Start met verkopen', text: 'De straat op, je netwerk in. Wij ondersteunen elke deal met snelle setup zodat jouw klanten snel live gaan.' },
      { title: 'Word wekelijks betaald', text: 'Converteer 2 zakelijke klanten in een week en je opstartuitbetaling valt diezelfde week binnen.' },
    ],
  },
  who: {
    kicker: 'Wie we zoeken',
    heading: 'Hunters met horeca in hun bloed.',
    items: [
      { icon: '🤝', title: 'Verbonden', text: 'Jij kent restauranthouders, of je weet hoe je bij ze binnenkomt. Een netwerk in quick-service, afhaal of bezorging is een voorsprong.' },
      { icon: '⚡', title: 'Zelfstandig', text: 'Jij bepaalt je eigen tempo en beheert je eigen pipeline. Wij geven je de tools, de training en de back-up. Jij brengt de drive.' },
      { icon: '🌍', title: 'Actief in NL, BE of DE', text: 'We zijn live in Nederland en België, en lanceren in 2026 in Duitsland. Vroege agents kiezen als eerste hun regio.' },
    ],
  },
  cta: {
    heading: 'Klaar om je portefeuille op te bouwen?',
    text: 'Meld je aan in 2 minuten. We nemen binnen twee werkdagen contact op om je introgesprek in te plannen.',
    button: 'Meld je aan via het formulier',
    small: 'Er gelden algemene voorwaarden. De volledige agentovereenkomst en commissievoorwaarden worden tijdens de onboarding vastgelegd.',
  },
}
